import { render, staticRenderFns } from "./ClientPackageUpload.vue?vue&type=template&id=36f6df6c&scoped=true&"
import script from "./ClientPackageUpload.vue?vue&type=script&lang=js&"
export * from "./ClientPackageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ClientPackageUpload.vue?vue&type=style&index=0&id=36f6df6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6df6c",
  null
  
)

export default component.exports